import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import {withRouter} from "react-router";
import Card from "react-bootstrap/cjs/Card";
import NPIf from "np-if";
import NPElse from "np-if/src/NPElse";
import Spinner from "react-bootstrap/Spinner";
import {money} from "../../lib/money/money";
import Col from "react-bootstrap/Col";

/**
 * Display the discounts applied to order
 *
 * @author América Mendoza  <amendoza@nodeport.co>
 * @author Darién Miranda <dmiranda@nodeport.co>
 * @author Oscar Peña <opena@nodeport.co>
 */


class OrderDiscounts extends React.Component {
    render() {
        const columns = [
            {
                dataField: 'name',
                text: 'Nombre',
                formatter:(v,row) =>{
                    return(
                        <div>
                            <a href={`/discounts/${row._id}`}>{v}</a>
                        </div>
                    )
                }
            },
            {
                dataField: 'value',
                text: 'Valor',
                formatter:(v,row) =>{
                    let txt = ''
                    if(row.type === 'fixed_amount'){
                        txt = `${money(v)}`
                    }
                    if(row.type === 'percentage'){
                        txt = `${v} %`
                    }
                    return txt
                }
            },
            

        ];
        return (
            <Col>
                <Card>
                    <Card.Body>
                        <Card.Title className={'text-capitalize'}>
                            Descuentos aplicados
                        </Card.Title>
                        <div className={'mb-2'}>
                            <NPIf condition={this.props.isLoading}>
                                <Spinner animation={'grow'} variant={'primary'}>
                                </Spinner>
                                <NPElse>
                                    <BootstrapTable keyField='_id'
                                                    data={this.props.discounts}
                                                    columns={columns}
                                                    noDataIndication={`No se aplicó ningún descuento`}
                                                    bordered={false}/>
                                </NPElse>
                            </NPIf>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        )
    }
}
export default withRouter(OrderDiscounts);
OrderDiscounts.propTypes    = {
    discounts: PropTypes.array,
    isLoading: PropTypes.bool
}
OrderDiscounts.defaultProps = {
    discounts: [],
    isLoading: false
}

